import { __exports as objectGetOwnPropertySymbols } from '../../../_virtual/object-get-own-property-symbols.js';

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

export { objectGetOwnPropertySymbols as default };
//# sourceMappingURL=object-get-own-property-symbols.js.map
